// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__PJftN","itemTitle":"ClientEmergencyInfo_itemTitle__3UM8N","itemText":"ClientEmergencyInfo_itemText__3KSdp"};